<template>
  <div id="charging-report">
    <a-form class="ant-advanced-search-form" :form="form" @submit="getInfos">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="Select Date">
            <a-range-picker @change="onDateChange" v-decorator="['range-picker', rangeConfig]" />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="Location">
            <a-select
              v-decorator="[
                'depot',
                {
                  rules: [{ required: true, message: 'Please select a location!' }],
                  initialValue:
                    this.SingleCompanyUser && displayDepots(this.CompanyMap.keys().next().value).length == 1
                      ? displayDepots(this.CompanyMap.keys().next().value)[0]
                      : undefined
                }
              ]"
              placeholder="Select location"
              :allowClear="true"
            >
              <template v-for="(companyItem, companyIndex) in displayCompanies">
                <a-select-opt-group :label="companyItem" :key="companyIndex">
                  <a-select-option
                    v-for="(depotItem, depotIndex) in displayDepots(companyItem)"
                    :key="depotIndex"
                    :value="depotItem"
                  >
                    {{ depotItem }}
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row justify="end">
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button type="primary" html-type="submit">
            Generate Report
          </a-button>
          <a-button :disabled="downloadDisabled" :style="{ marginLeft: '8px' }" type="primary" @click="printHtml">
            Print Report
          </a-button>
          <vue-csv-downloader :data="handleData" :fields="fields" :download-name="csvName">
            <a-button :style="{ marginLeft: '8px' }" type="primary" icon="download" :disabled="downloadDisabled">
              Download CSV
            </a-button>
          </vue-csv-downloader>
        </a-col>
      </a-row>
    </a-form>
    <br />
    <div class="search-result-list">
      <a-spin :spinning="loading">
        <div id="components-table-demo-size">
          <div v-show="canvasShow" ref="echarts" class="echarts" />
          <img id="printImg" v-show="!canvasShow" :src="canvasUrl" />
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import print from "print-js";
import VueCsvDownloader from "vue-csv-downloader";
import { mapState } from "vuex";
export default {
  data() {
    return {
      Options: {
        xAxis: {
          type: "time",
          useUTC: false,
          splitLine: {
            show: false
          },
          name: "Time (MM-DD HH:mm)",
          nameLocation: "center",
          nameGap: 35,
          nameTextStyle: {
            fontSize: 15,
            fontWeight: "bold"
          },
          axisLine: {
            lineStyle: {
              width: 2
            }
          },
          axisPointer: {
            label: {
              formatter: function(params) {
                const date = new Date(params.value);
                return (
                  (date.getMonth() + 1).toString().padStart(2, "0") +
                  "-" +
                  date
                    .getDate()
                    .toString()
                    .padStart(2, "0") +
                  "-" +
                  date
                    .getFullYear()
                    .toString()
                    .padStart(2, "0") +
                  " " +
                  date
                    .getHours()
                    .toString()
                    .padStart(2, "0") +
                  ":" +
                  date
                    .getMinutes()
                    .toString()
                    .padStart(2, "0")
                );
              }
            }
          },
          axisLabel: {
            formatter: function(value) {
              const date = new Date(value);
              return (
                (date.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                date
                  .getDate()
                  .toString()
                  .padStart(2, "0") +
                " " +
                date
                  .getHours()
                  .toString()
                  .padStart(2, "0") +
                ":" +
                date
                  .getMinutes()
                  .toString()
                  .padStart(2, "0")
              );
            }
          }
        },
        tooltip: {
          trigger: "axis",
          position: function(pt) {
            return [pt[0] + 15, "10%"];
          },
          axisPointer: {
            type: "cross"
          },
          formatter: function(params) {
            return "Timestamp: " + params[0].value[0] + "<br />AC Current: " + params[0].value[1] + " Amp";
          }
        },
        title: {
          left: "center",
          text: "AC Current Chart"
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          name: "Total AC Current (Amp)",
          nameLocation: "center",
          nameGap: 35,
          nameTextStyle: {
            fontSize: 15,
            fontWeight: "bold"
          },
          axisLine: {
            lineStyle: {
              width: 2
            }
          }
        },
        series: [
          {
            data: [],
            showSymbol: false,
            hoverAnimation: false,
            type: "line",
            name: "Timestamp"
          }
        ]
      },
      downloadDisabled: true,
      form: this.$form.createForm(this),
      rangeConfig: {
        rules: [{ type: "array", required: true, message: "Please select Date!" }]
      },
      startTime: "",
      endTime: "",
      data: [],
      canvasUrl: "",
      canvasShow: true,
      fields: ["timestampUtc", "totalCurrent"],
      csvName: "",
      chart: "",
      loading: false
    };
  },

  components: {
    VueCsvDownloader
  },

  mounted() {
    this.chart = this.$echarts.init(this.$refs.echarts);
    this.chart.setOption(this.Options);
  },
  watch: {
    handleData(val) {
      this.Options.series[0].data = [];
      if (val.length > 0) {
        val.forEach(item => {
          this.Options.series[0].data.push([
            this.$moment(item.timestampUtc)
              .local()
              .format("YYYY-MM-DD HH:mm"),
            item.totalCurrent
          ]);
        });
        this.chart.setOption(this.Options);
        setTimeout(() => {
          this.canvasUrl = document.querySelector("canvas").toDataURL();
        }, 1000);
      }
    }
  },

  computed: {
    ...mapState(["CompanyMap", "SingleCompanyUser"]),

    handleData() {
      // copy data over, and sort/filter it according to requirements.
      const data = this.data;
      return data.sort((x, y) => {
        const xval = this.$moment(x.timestampUtc).valueOf();
        const yval = this.$moment(y.timestampUtc).valueOf();
        return xval - yval;
      });
    },

    // function to display the list of companies user is authenticated for.
    displayCompanies() {
      let companyList = [];
      this.CompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    }
  },

  methods: {
    // function that returns the list of depots associated with that company.
    displayDepots(company) {
      return this.CompanyMap.get(company).depots.sort();
    },

    getInfos(e) {
      e.preventDefault();
      this.data = [];
      this.form.validateFields(async (err, fieldsValue) => {
        if (err) {
          return;
        }
        this.loading = true;
        const promiseArr = [];
        const rangeValue = fieldsValue["range-picker"];
        const startDay = this.$moment(rangeValue[0]).format("YYYY-MM-DD");
        const endDay = this.$moment(rangeValue[1]).format("YYYY-MM-DD");
        const startTimeUtc = this.$moment(rangeValue[0]) // convert local time 00:00 to UTC time.
          .startOf("day")
          .utc();
        const endTimeUtc = this.$moment(rangeValue[1]) // convert local time 23:59 to UTC time.
          .endOf("day")
          .utc();
        const rangeUtc = this.$moment.range(startTimeUtc, endTimeUtc).snapTo("day");
        const daysArray = Array.from(rangeUtc.by("days"));
        // check the size of the daysArray to make sure it is within the allowed range.
        if (daysArray.length > 32) {
          this.$message.error("Range over limit (1 month). Please pick a shorter duration.");
          this.loading = false;
          return;
        }
        this.csvName = `AC_Current_Report_${startDay}_${endDay}_${fieldsValue.depot}.csv`;
        // add region to the query parameter before making the API call.
        var regionSelected;
        this.CompanyMap.forEach(valueObject => {
          if (valueObject.depots.includes(fieldsValue.depot)) {
            regionSelected = valueObject.region;
          }
        });
        daysArray.forEach(day => {
          let dateTypeDepot = `${day.format("YYYY-MM-DD")}#LTR#${fieldsValue.depot}`;
          let data = {
            dateTypeDepot,
            startTime: startTimeUtc.toJSON(),
            endTime: endTimeUtc.toJSON(),
            region: regionSelected
          };
          promiseArr.push(this.sendData(data));
        });
        try {
          let dataArr = await Promise.all(promiseArr);
          let data = dataArr.flat(Infinity);
          // check if no data is returned; display a message to user in that case.
          if (!data.length) {
            throw new Error("No data available for selected fields!");
          }
          this.data = data;
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
          return;
        }
        this.loading = false;
        this.downloadDisabled = false;
      });
    },

    printHtml() {
      this.canvasShow = false;
      print("components-table-demo-size", "html");
      this.canvasShow = true;
    },

    async sendData(data) {
      try {
        let response = await this.$axios.get("https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/chargingus", {
          params: data
        });
        let items = response.data.Items;
        return Promise.resolve(items);
      } catch (error) {
        // if no response is available, means it is a network error.
        if (!error.response) {
          return Promise.reject(new Error("Network Error. Please try again!"));
        } else {
          let response = error.response;
          if (response.status == 400) {
            return Promise.reject(response.data.message);
          }
        }
      }
    },

    onDateChange() {
      this.downloadDisabled = true;
    }
  }
};
</script>

<style>
.echarts {
  width: calc(100% - 200px);
  height: 500px;
}
</style>
